export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["技术支持请求"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["来自"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["聊天"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加消息"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["文件"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您可以上传一个或多个文件。文件最大大小为10MB。"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["消息内容"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发送"])}
}